import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import type { ApiBanner, ApiLocation, ApiFeaturedSection } from '../types';

import i18n from '../../../i18n';

export function useBanners() {
    return useQuery({
        queryKey: ['cms', 'banners', i18n.language],
        queryFn: async () => {
            const res = await api.get<ApiBanner[]>('/api/cms/banners');
            return (res.data || res as any) as ApiBanner[];
        },
    });
}

export function useLocations() {
    return useQuery({
        queryKey: ['cms', 'locations', i18n.language],
        queryFn: async () => {
            const res = await api.get<ApiLocation[]>('/api/cms/locations');
            return (res.data || res as any) as ApiLocation[];
        },
    });
}

export function useFeaturedSection(key: string, options?: { enabled?: boolean }) {
    return useQuery({
        queryKey: ['cms', 'featured', key, i18n.language],
        queryFn: async () => {
            try {
                const res = await api.get<ApiFeaturedSection>(`/api/cms/featured/${key}`);
                return res.data;
            } catch (error: any) {
                if (error.response?.status === 404) return null;
                throw error;
            }
        },
        enabled: options?.enabled !== undefined ? options.enabled && !!key : !!key,
        retry: (failureCount, error: any) => {
            if (error.response?.status === 404) return false;
            return failureCount < 3;
        }
    });
}
